import { __extends } from "tslib";
var BaseError = /** @class */ (function (_super) {
    __extends(BaseError, _super);
    function BaseError(message, cause) {
        var _this = this;
        var msg = message;
        var err = { cause: cause };
        while (err.cause && err.cause instanceof Error) {
            msg = message + "\n\t\u2192 " + cause;
            err = err.cause;
        }
        _this = _super.call(this, msg) || this;
        _this.cause = cause;
        _this.name = _this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(_this, _this.constructor);
        }
        else {
            _this.stack = new Error().stack;
        }
        Object.setPrototypeOf(_this, _this.constructor.prototype);
        return _this;
    }
    return BaseError;
}(Error));
export default BaseError;
//# sourceMappingURL=base-error.js.map